import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./globals.css";

// Initialize Sentry (using standardized environment variables)
const sentryDsn = import.meta.env.VITE_FRONTEND_SENTRY_DSN;
const sentryEnvironment = import.meta.env.VITE_FRONTEND_SENTRY_ENVIRONMENT || "development";
const enableSentryLogs = import.meta.env.VITE_FRONTEND_ENABLE_SENTRY_LOGS === "true";
const sentryTracesRate = parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || "1.0");
const sentryProfilesRate = parseFloat(import.meta.env.VITE_SENTRY_PROFILES_SAMPLE_RATE || "1.0");
const sentryRelease = import.meta.env.VITE_SENTRY_RELEASE;

// Debug logging to verify Sentry configuration
console.log("Sentry Configuration:", {
  dsn: sentryDsn ? "✓ DSN provided" : "✗ DSN missing",
  environment: sentryEnvironment,
  enabled: enableSentryLogs,
  tracesRate: sentryTracesRate,
  profilesRate: sentryProfilesRate
});

// Only initialize Sentry if DSN is provided and logging is enabled
if (sentryDsn && enableSentryLogs) {
  Sentry.init({
    dsn: sentryDsn,
    environment: sentryEnvironment,
    release: sentryRelease,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration()
    ],
    // Tracing
    tracesSampleRate: sentryTracesRate, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/silent-kiwi-beam\.onrender\.com\/api/,
      /^https:\/\/matt-project\.onrender\.com\/api/
    ],
    // Enable logs to be sent to Sentry
    enableLogs: true,
    // Set profileSessionSampleRate to 1.0 to profile during every session.
    // The decision, whether to profile or not, is made once per session (when the SDK is initialized).
    profileSessionSampleRate: sentryProfilesRate,
    debug: sentryEnvironment === "development", // Debug mode only in development
    attachStacktrace: true,
  });
} else {
  console.log("Sentry logging disabled or DSN not provided - logs will stay local");
}

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);
